export enum Platform {
  YOUTUBE = "YOUTUBE",
  YOUTUBE_SHORTS = "YOUTUBE_SHORTS",
  INSTAGRAM_REELS = "INSTAGRAM_REELS",
  INSTAGRAM = "INSTAGRAM",
  FACEBOOK = "FACEBOOK",
  LINKEDIN = "LINKEDIN",
  GOOGLE_MY_BUSINESS = "GMB",
  TIKTOK_REELS = "TIKTOK_REELS",
  /** TikTok connected-profile key (SGL-170); posts still use TIKTOK_REELS. */
  TIKTOK = "TIKTOK",
  FACEBOOK_REELS = "FACEBOOK_REELS",
  LINKEDIN_REELS = "LINKEDIN_REELS",
  WORDPRESS = "WORDPRESS",
  /** Google Drive (files / picker); distinct from GMB / YouTube OAuth clients. */
  GOOGLE_DRIVE = "GOOGLE_DRIVE",
  /**
   * Google Search Console. A connected "profile" is one verified property
   * (`sc-domain:example.com` or `https://example.com/`). Read-only analytics — not a
   * publishing destination, so it is excluded from the social-post platform filter.
   */
  GOOGLE_SEARCH_CONSOLE = "GOOGLE_SEARCH_CONSOLE",
  /**
   * Bing Webmaster Tools (SGL-134). A connected "profile" is one verified site, its id
   * the site URL exactly as Bing returns it. Read-only analytics, like Search Console.
   */
  BING_WEBMASTER = "BING_WEBMASTER",
  // Add other platforms as needed
}

/**
 * Platforms that are connections but not social-post publishing destinations, so they
 * never belong in a platform picker for a post.
 *
 * GOOGLE_DRIVE is deliberately absent: it is also not a publishing destination, but it
 * is already rendered by the existing filter and removing it is not this list's job.
 */
export const NON_PUBLISHING_PLATFORMS: readonly Platform[] = [
  Platform.WORDPRESS,
  Platform.GOOGLE_SEARCH_CONSOLE,
  Platform.BING_WEBMASTER,
  // Connection key only; TikTok posts use TIKTOK_REELS until the composer ships (SGL-170 Phase 4).
  Platform.TIKTOK,
];